import {
  ArrowBack as ArrowBackIcon,
  Cancel,
  Edit,
  History as HistoryIcon,
  Save,
} from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { InvestmentEntity } from '../../models/InvestmentEntity';
import { StyledIconButton } from '../styles/StyledButtons';
import { StyledHeading } from '../styles/styles';

interface EntityManagementHeaderProps {
  entity: InvestmentEntity;
  isEditing: boolean;
  editedName: string;
  onEditToggle: () => void;
  onSaveChanges: () => void;
}

export const EntityManagementHeader: React.FC<EntityManagementHeaderProps> = ({
  entity,
  isEditing,
  editedName,
  onEditToggle,
  onSaveChanges,
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
      }}
    >
      <StyledHeading>Investment Entity Details</StyledHeading>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Tooltip title="Back">
          <StyledIconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </StyledIconButton>
        </Tooltip>
        {!isEditing ? (
          <>
            <Tooltip title="Edit Entity">
              <StyledIconButton onClick={onEditToggle}>
                <Edit />
              </StyledIconButton>
            </Tooltip>
            <Tooltip title="Activity Log">
              <StyledIconButton
                onClick={() => navigate(`/activityLogs/INVESTMENT_ENTITY/${entity.id}`)}
              >
                <HistoryIcon />
              </StyledIconButton>
            </Tooltip>
          </>
        ) : (
          <>
            <Tooltip title="Cancel">
              <StyledIconButton onClick={onEditToggle}>
                <Cancel />
              </StyledIconButton>
            </Tooltip>
            <Tooltip title="Save Changes">
              <StyledIconButton onClick={onSaveChanges} disabled={!editedName.trim()}>
                <Save />
              </StyledIconButton>
            </Tooltip>
          </>
        )}
      </Box>
    </Box>
  );
};
